import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class WithCredentialsInterceptor implements HttpInterceptor {

  constructor() {  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //console.log("outgoing request",req);
    req = req.clone({ withCredentials: true });
    //console.log("new outgoing request",req);
    //return next.handle(req);
    return next
    .handle(req)
    .pipe(
       tap((ev: HttpEvent<any>) => {
         //console.log("got an event",ev)
         if (ev instanceof HttpResponse) {
           //console.log('event of type response', ev);
         }
       })
    );
  }
}
